import { JSX } from 'react';

import { useDynatrace } from '@src/hooks/use-dynatrace.hook';
import { LayoutContainer } from '@src/components/layout';
import { AccentCircle } from '@src/components/accent-circle';
import { CTA } from '@src/components/footer';

import '@src/components/error/error-page-layout.scss';

interface ErrorPageLayoutProps {
  headerText: string;
  bodyContent: JSX.Element;
  primaryCTA?: CTA;
  showLegal?: boolean;
  showFooterLegal?: boolean;
}

export const ErrorPageLayout = ({
  headerText,
  bodyContent,
  primaryCTA,
  showLegal = false,
  showFooterLegal = false,
}: ErrorPageLayoutProps): JSX.Element => {
  const { addAction } = useDynatrace();
  addAction('Rendering Error Page Layout');
  return (
    <>
      <LayoutContainer
        primaryCTA={primaryCTA}
        showLegal={showLegal}
        showFooterLegal={showFooterLegal}
      >
        <div className="hc-pet-insurance__media-container">
          <svg
            aria-hidden="true"
            className="hc-pet-insurance__media-accent"
            focusable="false"
            role="img"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="50" cy="50" r="46" />
          </svg>
          <img
            alt=""
            className="hc-pet-insurance__media-image"
            src="/pet-insurance/img/dachshund-tilting-head.png"
          />
        </div>
        <section className="hc-pet-insurance__body">
          <div className="hc-pet-insurance__text-title">
            <h1>{headerText}</h1>
          </div>
          {bodyContent}
        </section>
      </LayoutContainer>
      <AccentCircle />
    </>
  );
};
